import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const GET = gql`
  query AccountGet {
    viewer {
      id
      account {
        ...AccountFragment
      }
    }
  }
  ${AccountFragment}
`;
